import { useAlert } from 'react-alert';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  IBrandMenuOrderItem,
  IMenuUnificationOrderResponse,
  IMUErrorResponse,
} from '../../types/brandMenu';
import { AxiosResponse } from 'axios';
import {
  setCurrentTransactionItemStatus,
  setOrderError,
  setErrorCartItemId,
} from '../../reducers/orderSlice';
import { OrderStatus } from '../../reducers/orderSlice.constants';
import { selectOrderErrorCartItemId } from '../../selectors/order';
import { findOrderIndex } from '../../utils/menuUnification.utils';

const useMenuUnificationOrderHandlers = () => {
  const dispatch = useAppDispatch();
  const alert = useAlert();
  const errorCartItemId = useAppSelector(selectOrderErrorCartItemId);

  const menuUnificationOrderFailureCallback = ({
    validCartItemIds,
    error,
    menuModuleItems,
    menuModuleItemsCartItemIds,
  }: {
    validCartItemIds: number[];
    error: AxiosResponse;
    menuModuleItems: IBrandMenuOrderItem[];
    menuModuleItemsCartItemIds: number[];
  }) => {
    let errorMessage = '';
    let currentErrorCartItemId = -1;

    if (error?.data?.detail?.[0]?.path) {
      const errorItemIndex = findOrderIndex(
        error.data.detail[0].path,
        menuModuleItems
      );

      if (errorItemIndex >= 0)
        currentErrorCartItemId = menuModuleItemsCartItemIds[errorItemIndex];
    }

    if (currentErrorCartItemId < 0) {
      currentErrorCartItemId =
        !errorCartItemId ||
        !validCartItemIds.find((id) => id === errorCartItemId)
          ? validCartItemIds[validCartItemIds.length - 1]
          : errorCartItemId;
    }

    if (error?.status === 400) {
      errorMessage = (error?.data as IMUErrorResponse)?.error_type || '';
    }
    dispatch(
      setCurrentTransactionItemStatus({
        cartItemId: String(currentErrorCartItemId),
        orderStatus: OrderStatus.failed,
      })
    );
    dispatch(setOrderError(errorMessage));
    dispatch(setErrorCartItemId(currentErrorCartItemId));
  };

  const menuUnificationOrderSuccessCallback = ({
    data,
  }: {
    data: IMenuUnificationOrderResponse[];
  }) => {
    const message = 'Succeed to send order to menu module';
    alert.success(message, { timeout: 3000 });
  };

  return {
    menuUnificationOrderFailureCallback,
    menuUnificationOrderSuccessCallback,
  };
};

export default useMenuUnificationOrderHandlers;
